module.exports = __webpack_public_path__ + "static/media/oberflex-acajout17-2560x1440.bc18ba15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-acajout17-2560x1440.jpg
// module id = 967
// module chunks = 37